import React from "react";
import { Attachment as AttachmentType } from "../../../../types/messages";
import AttachmentIcon from "../../MessageAnalysis/AttachmentIcon";
import {
  attachmentWrapper,
  asideClasses,
  titleClasses,
  bodyClasses,
  descriptionClasses,
  attachmentBodyClasses,
  footerClasses,
  iconTimerClasses,
} from "./style";
import { FontIcon } from "@fluentui/react";
import { stripNbsp } from "../../../../utils";

type Props = {
  attachment: AttachmentType;
};

const Attachment: React.FC<Props> = (props) => {
  const { attachment } = props;

  return (
    <div className={attachmentWrapper}>
      <div className={attachmentBodyClasses}>
        <div className={asideClasses}>
          <AttachmentIcon size={20} type={attachment.attachmentType} />
        </div>
        <div className={bodyClasses}>
          <div className={titleClasses}>{attachment.attachmentName}</div>
          <div className={descriptionClasses}>{stripNbsp(attachment.comparisonSummary)}</div>
        </div>
      </div>
      <div className={footerClasses}>
        {attachment.timeToRead && (
          <div>
            <FontIcon aria-label="Timer" iconName="BufferTimeBefore" className={iconTimerClasses} />
            Time to read: {attachment.timeToRead}
          </div>
        )}
        <div>{attachment.changesSummary}</div>
      </div>
    </div>
  );
};

export default Attachment;
